import { Link, useLocation } from "react-router-dom";
import "../styles/Sidebar.css";

export default function Sidebar() {
  const location = useLocation();

  return (
    <div className="sidebar">
      <nav className="sidebar-nav">

        <Link
          to="/dashboard"
          className={`sidebar-link ${
            location.pathname === "/dashboard" ? "active" : ""
          }`}
        >
          Dashboard
        </Link>
        {/* <Link
          to="/admin"
          className={`sidebar-link ${
            location.pathname === "/admin" ? "active" : ""
          }`}
        >
          City-Wise-leads
        </Link>
        <Link
          to="/member-directory"
          className={`sidebar-link ${
            location.pathname === "/member-directory" ? "active" : ""
          }`}
        >
          Member Directory
        </Link> */}
        <Link
          to="/leads"
          className={`sidebar-link ${
            location.pathname === "/leads" ? "active" : ""
          }`}
        >
          Leads
        </Link>

      </nav>
    </div>
  );
}
